import React from 'react';
import PropTypes from 'prop-types';
import TriggerLink from './Link';
import TriggerDisclaimer from './Disclaimer';


const Trigger = function Trigger({
  templateId,
  programName,
  location,
  action,
  content,
}) {
  switch (templateId) {
    case 'primary':
      return <TriggerLink action={action} location={location || {}} content={content} />;
    case 'disclaimer':
      return (
        <TriggerDisclaimer
          action={action}
          programName={programName}
          location={location}
        />
      );
    default:
      return null;
  }
};

Trigger.propTypes = {
  action: PropTypes.func.isRequired,
  templateId: PropTypes.string.isRequired,
  programName: PropTypes.string,
  location: PropTypes.oneOfType([
    PropTypes.shape({
      region: PropTypes.string,
    }),
    PropTypes.string,
  ]),
  content: PropTypes.shape({}).isRequired,
};

Trigger.defaultProps = {
  programName: '',
  location: '',
};

export default Trigger;
